import { HttpRequest } from 'app/libs/http-client';

import { BaseFilterModel, DataGridFilter } from '../create-data-grid-filter';

export const anyOfAsyncFilterModelName = 'any_of_async_filter';

export type AnyOfAsyncFilterModel = BaseFilterModel<
  number[],
  typeof anyOfAsyncFilterModelName
>;

export type RenderOptionsList = {
  label: string;
  value: number;
}[];

type DataRequest = () => HttpRequest;
type PrepareRequestedData = (data: unknown) => RenderOptionsList;

export type AnyOfAsyncFilterParams = {
  /**
   * The name of the field for filtering in the server-side API
   */
  filterName: string;

  asyncData: {
    request: DataRequest;
    prepareData: PrepareRequestedData;
  };
  closeWhenChanged?: boolean;
};

export type AnyOfAsyncDataGridFilter = DataGridFilter<
  AnyOfAsyncFilterModel,
  AnyOfAsyncFilterParams
>;

type CreateAnyOfAsyncFilterModelParams = {
  value: number[];
  filterName: string;
};
export const createAnyOfAsyncFilterModel = ({
  value,
  filterName,
}: CreateAnyOfAsyncFilterModelParams): AnyOfAsyncFilterModel => {
  return {
    filterModelName: anyOfAsyncFilterModelName,
    value,
    filterName,
  };
};
